"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var sizes = {
  'lg': 16,
  '2x': 24,
  '3x': 32,
  '4x': 48,
  '5x': 64
};
var baseStyle = {
  position: 'relative',
  userSelect: 'none',
  textAlignVertical: 'text-bottom',
  display: 'inline-block'
};
var getContent = function getContent(fillContent, lightContent, regularContent) {
  var weight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'regular';
  switch (weight) {
    case 'regular':
      return regularContent;
    case 'light':
      return lightContent;
    case 'fill':
      return fillContent;
  }
  return regularContent;
};
var createIconComponent = function createIconComponent(_ref) {
  var fillContent = _ref.fillContent,
    lightContent = _ref.lightContent,
    regularContent = _ref.regularContent,
    height = _ref.height,
    width = _ref.width,
    viewBox = _ref.viewBox;
  return function (props) {
    return /*#__PURE__*/(0, _react.createElement)('svg', _objectSpread(_objectSpread({}, props), {}, {
      style: _objectSpread(_objectSpread({}, baseStyle), {}, {
        height: sizes[props.size] || 14 + 'px',
        fill: props.color || 'currentColor'
      }, props.style),
      viewBox: viewBox || "0 0 ".concat(width, " ").concat(height)
    }), getContent(fillContent, lightContent, regularContent, props.weight));
  };
};
var _default = exports["default"] = createIconComponent;